import { ArrowLeft } from "lucide-react";
import React, { useState, useEffect } from "react";
import { CustomButton, CustomButtonLight } from "../UI/CustomButtons";
import styles from "../../_css/Home.module.css";
import { useDispatch } from "react-redux";
import { HOME_DATA_SESSION_DETAILS } from "../../data/staticDataHome";
import { useSelector } from "react-redux";
import { resetPage } from "../../_store/reducers/pageChangeReducer";
import VideoPlayer from "../Modals/VideoPlayer";

function SessionDetails({ handleResumeSession }) {
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);

  const dispatch = useDispatch();

  const sessionData = sessionStorage.getItem("sessionData");
  const sessionDataParsed = JSON.parse(sessionData);

  const lang = useSelector((state) => state.language.lang);
  const { sessionDetailsTitle, startSessionBtnText, watchVideoBtnText } =
    HOME_DATA_SESSION_DETAILS[lang];

  const handleWatchVideo = () => {
    setShowVideoPlayer(true);
  };



 

  return (
    <div className={styles.sessionDetails}>
      <VideoPlayer
        show={showVideoPlayer}
        onHide={() => setShowVideoPlayer(false)}
        videoLink={ lang === "ar" ? sessionDataParsed?.video_link_ar : sessionDataParsed?.video_link}
      />
      <div className={styles.sessionDetailsHeader}>
        <i className="cursor-pointer" onClick={() => dispatch(resetPage())}>
          <ArrowLeft size={16} />
        </i>
        <h5>{sessionDetailsTitle}</h5>
      </div>
      <hr className="m-0" />
      <div className={styles.sessionDetailsContent}>
        <div className={styles.sessionDetailsContentLeft}>
          <img
            className={styles.sessionDetailsImageMobile}
            src={
              sessionDataParsed?.image_url ||
              `${process.env.REACT_APP_PROJECT_URL}/img/square-static-img.png`
            }
            alt="session"
            width="100%"
          />
          <h4>
            {lang === "ar"
              ? sessionDataParsed?.title_arabic
              : sessionDataParsed?.title}
          </h4>
          <p
            className={styles.sessionDetailsDescription}
            dangerouslySetInnerHTML={{
              __html:
                lang === "ar"
                  ? sessionDataParsed?.description_arabic
                  : sessionDataParsed?.description,
            }}
          ></p>
          <CustomButtonLight
            onClick={() => handleWatchVideo()}
            text={watchVideoBtnText}
            icon="video"
          />
          <CustomButton
            text={startSessionBtnText}
            onClick={() => handleResumeSession()}
          />
        </div>
        <img
          className={styles.sessionDetailsImageDesktop}
          src={
            sessionDataParsed?.image_url ||
            `${process.env.REACT_APP_PROJECT_URL}/img/square-static-img.png`
          }
          alt="session"
          width="100%"
        />
      </div>
    </div>
  );
}

export default SessionDetails;
